import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { DateSelectService } from './date-select.service';

@Injectable({
  providedIn: 'root'
})
export class HydroConditionService {

  private hydroConditionSource = new BehaviorSubject<HydroCondition>(null);
  currentHydroCondition = this.hydroConditionSource.asObservable();

  private date: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private dateSelectObject: DateSelectService) {
        // Whenever you get a date, grab the HydroCondition data
        this.dateSelectObject.currentDate.subscribe((result) => {
          this.date = result;
          this.getHydroCondition();
        });
  }

  getHydroCondition() {
    this.http.get<HydroCondition>(`${this.baseUrl}api/HydroCondition/search?EffectiveForDate=${this.date}`, {observe: 'response'}).subscribe(response => {
      if(response.status === 200) {
        this.changeHydroCondition(response.body);
      }
    });
  }

  postHydroCondition(newCondition: number) {
    this.http.post(`${this.baseUrl}api/HydroCondition/?newDemandConditionId=${newCondition}&newEffectiveFromDate=${this.date}`, {}, {observe: 'response'}).subscribe(response => {
      if(response.status === 200) {
        this.getHydroCondition();
      }
    });
  }

  changeHydroCondition(hydroCondition: HydroCondition) {
    this.hydroConditionSource.next(hydroCondition);
  }

}

export interface HydroCondition {
  id: number,
  demandCondition: string,
  demandConditionId: number,
  EffectiveFromDate: any
}
